import { render, staticRenderFns } from "./bodyShamingInterpretation.vue?vue&type=template&id=0b02911d&scoped=true"
import script from "./bodyShamingInterpretation.vue?vue&type=script&lang=js"
export * from "./bodyShamingInterpretation.vue?vue&type=script&lang=js"
import style0 from "./bodyShamingInterpretation.vue?vue&type=style&index=0&id=0b02911d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02911d",
  null
  
)

export default component.exports